import React from "react";
import { useLocation } from "react-router-dom";
import { Result, Typography } from "antd";

const { Paragraph, Text } = Typography;

const NotFound = () => {
  const location = useLocation();

  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      padding: "20px",
      backgroundColor: "#f0f2f5"
    }}>
      <Result
        status="404"
        title="404"
        subTitle={
          <div>
            <Paragraph>
              Oops! The page <Text code>{location.pathname}</Text> does not exist.
            </Paragraph>
            <Paragraph>
              It might have been removed or is temporarily unavailable. If the issue persists, please contact the respective person/administrator.
            </Paragraph>
          </div>
        }

      />
    </div>
  );
};

export default NotFound;
